// extracted by css-extract-rspack-plugin
export default {"button":"oeMk6F","button-extra":"dy5GGb","buttonExtra":"dy5GGb","mask":"Lohpr9","wrapper":"ggrz6m","icon":"XlM89s","label":"XwYBNu"};